import { createAction } from 'redux-act'

export const initSocialNetworks = createAction('init social networks')
export const socialSharePost = createAction('social share post')
export const initNotificationSystem = createAction('init notification system')
export const addNotification = createAction('add notification')
export const showShareDialog = createAction('show share dialog')
export const doShare = createAction('do share')
export const showPreloader = createAction('show preloader state')



// WEBPACK FOOTER //
// app/javascript/src/actions/index.js